<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="search-results-filters">
    <div class="search-results-filters-title">{{ $t('sort_by') }}</div>
    <select v-model="selectedFilter" class="sort-by-filter" @change="sortFilterChange">
      <option
        v-for="o in filteredFiltersByType"
        :key="o.id"
        :value="o.value"
        :label="$t(o.label)"
      />
    </select>
  </div>
</template>

<script>
import filters from '@/assets/data/filters.json'

/**
 * Filter for sort results searched
 * @example [none]
 */
export default {
  name: 'FilterSort',
  props: {
    type: {
      type: String,
    },
  },
  data() {
    return {
      filters: filters,
      selectedFilter: this.$route.query.sortBy ? this.$route.query.sortBy : 'relevance',
    }
  },
  computed: {
    filteredFiltersByType() {
      if (this.type !== 'fav-list') {
        return this.filters.sortBy.filter(el => el.id !== '6' && el.id !== '7')
      } else {
        return this.filters.sortBy
      }
    },
  },
  methods: {
    /**
     * Update URL query search params with sortBy information
     * @public This is a public method
     */
    sortFilterChange() {
      /** Triggers when change the value of sort
       * @event toggle-data-loading
       */
      this.$emit('toggle-data-loading')
      let queryUpdate = { ...this.$route.query }
      delete queryUpdate.page
      if (this.selectedFilter !== 'relevance') {
        queryUpdate.sortBy = this.selectedFilter
        this.$router.push({
          name: this.type === 'fav-list' ? 'Profile' : 'Search',
          params: { params: this.$route.params.params },
          query: queryUpdate,
        })
      } else {
        delete queryUpdate.sortBy
        this.$router.push({
          name: this.type === 'fav-list' ? 'Profile' : 'Search',
          params: { params: this.$route.params.params },
          query: queryUpdate,
        })
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.search-results-filters
  display: flex
  align-items: center
  gap: vw(10px)

.search-results-filters-title
  m-font-size(14, 20)
  color: $grey

.sort-by-filter
  m-font-size(14, 20)
  padding: 0 vw(10px)
  height: vw(32px)
  border: 1px solid $grey
  border-radius: 4px
  background-color: transparent
  color: #000
  font-weight: 600
  cursor: pointer
</style>
